import { inject, Injectable } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { firstValueFrom } from 'rxjs';
import {
  ConfirmDialogComponent,
  type ConfirmDialogConfirmation,
  type ConfirmDialogData,
  type ConfirmDialogResult,
} from './confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private readonly dialog = inject(Dialog);

  async confirm(data: ConfirmDialogData): Promise<boolean> {
    return (await this.confirmWithOption(data)) !== null;
  }

  /** Like `confirm`, but keeps the optional checkbox state so the caller can branch on it. Null when dismissed. */
  async confirmWithOption(data: ConfirmDialogData): Promise<ConfirmDialogConfirmation | null> {
    const dialogRef = this.dialog.open<ConfirmDialogResult, ConfirmDialogData>(ConfirmDialogComponent, {
      data,
      autoFocus: 'dialog',
      restoreFocus: true,
      panelClass: 'ai-chat-dialog-panel',
      backdropClass: 'ai-chat-dialog-backdrop',
    });
    const result = await firstValueFrom(dialogRef.closed);
    if (result === true) return { confirmed: true };
    if (typeof result === 'object' && result !== null && result.confirmed === true) return result;
    return null;
  }
}
